// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconFire = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12.234 18.992a3 3 0 01-.468 0C8.977 18.787 10.074 15.026 12 13c1.926 2.027 3.023 5.788.234 5.991" />,
    <path
      fillRule="evenodd"
      d="M12.004 1.617l-.597.578c-3.603 2.622-6.6 6.64-7.648 10.483-.527 1.932-.582 3.9.124 5.637.719 1.765 2.171 3.157 4.392 3.994 1.167.44 2.42.691 3.725.691s2.558-.251 3.725-.69c2.22-.838 3.673-2.23 4.392-3.995.706-1.736.65-3.705.124-5.637-1.048-3.844-4.045-7.86-7.647-10.482zM5.736 17.561c.479 1.177 1.468 2.207 3.245 2.877A8.5 8.5 0 0012 21c1.047 0 2.06-.2 3.02-.562 1.776-.67 2.765-1.7 3.244-2.877.491-1.207.5-2.7.047-4.357-.854-3.13-3.277-6.552-6.311-8.95-3.034 2.398-5.458 5.82-6.311 8.95-.452 1.657-.444 3.15.047 4.357"
    />
  );
export default SvgIconFire;
